export default {"src":"/_next/static/media/play.b02db3d5.svg","height":21,"width":18,"blurWidth":0,"blurHeight":0};